import React from "react";
import { Box } from "@mui/material";
import PropertyRepairsList from "../PropertyRepairsList";

/**
 * 修繕一覧 (PropertyRepairsList)。旧「収支」内サブ向け。物件詳細の「修繕」上タブでも同種 UI を使用。
 *
 * Phase 2 実装状況:
 *   ✅ 対象区分 (専有部/設備/付帯設備) 拡張        → RepairWorkCreateModal
 *   ✅ 関連経費セクション (ExpenseRecord 自動生成) → LinkedExpensesSection
 *   ✅ 関連点検の linked_repair_id 紐付け          → InspectionResultDialog
 *   ✅ 登録モーダル → ドロワー化                     → RepairWorkCreateModal (CustomDrawer)
 *   ☐  専有部グルーピング → フラット一覧 + 対象区分チップ (未実施 / 要設計確認)
 */

interface RepairSubTabProps {
  propertyId: string;
  propertyName: string;
}

const RepairSubTab: React.FC<RepairSubTabProps> = ({
  propertyId,
  propertyName,
}) => {
  return (
    <Box>
      <PropertyRepairsList
        propertyId={propertyId}
        propertyName={propertyName}
      />
    </Box>
  );
};

export default RepairSubTab;
